import Endpoints = require("../Endpoints");

import type { RequestHandler as RH } from "../RequestHandler";

import type {
	RESTGetAPIGatewayBotResult,
	RESTGetAPIGatewayResult,
	APIApplication,
	RESTPatchCurrentApplicationJSONBody
} from "discord-api-types/v10";





class BotMethods {








	public constructor(public requestHandler: RH) {}











	public async getGateway(): Promise<RESTGetAPIGatewayResult> {
		return this.requestHandler.request(Endpoints.GATEWAY, {}, "get", "json");
	}











	public async getGatewayBot(): Promise<RESTGetAPIGatewayBotResult> {
		return this.requestHandler.request(Endpoints.GATEWAY_BOT, {}, "get", "json");
	}










	public async getApplicationInfo(): Promise<APIApplication> {
		return this.requestHandler.request(Endpoints.OAUTH2_APPLICATION("@me"), {}, "get", "json");
	}














	public async updateApplicationInfo(data: RESTPatchCurrentApplicationJSONBody): Promise<APIApplication> {
		return this.requestHandler.request(Endpoints.OAUTH2_APPLICATION("@me"), {}, "patch", "json", data);
	}
}

export = BotMethods;
